export default __webpack_public_path__ + "6b7479bae12e2b1cf1a88619918743bf.jpg";